import React, { useEffect, useState } from 'react'
import ReadAxios from '../../axiosComponent/read'
import cogoToast from 'cogo-toast'
import { Table, Form as FormUi, Header, Icon, Button, Segment } from 'semantic-ui-react'
import Axios from 'axios';
import { Field, FieldArray } from 'formik'
import { MyNormalInput } from '../../apiInputComponent/myInput'
import ReactDatePicker from 'react-datepicker'
import moment from 'moment'
import TyreSerialNumber from '../../apiInputComponent/tyreSerialNumber'
import APP_CONSTANTS from '../../../config/constants';
import VehicleAttachedSerialNumber from './vehicleSerialNumber';
import { DATE_FORMATS } from '../../../utils/constants';


const VehicleEditTyreTable = (props) => {
  const [position, setposition] = useState(props.storedTyre)
  const [oldPosition, setoldPosition] = useState(props.oldStoredTyres)
  const [getTyres, setgetTyres] = useState([]);
  const [receivedTyreData, setReceivedTyreData] = useState([])
  const [deleteTyre, setDeleteTyre] = useState([])
  const [deleteArray, setDeleteArray] = useState([])
  const [disable, setDisable] = useState([])
  const [existingSerialNumber, setexistingSerialNumber] = useState([])
  let initialState = [];
  let excpectedData = []
  useEffect(() => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')
    let data = JSON.stringify
      ({
        api_token: token,
        customerNumber: customerNo,
        userId: userId,
        checkDeletedRecord: 1
      })
    Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vehicleTyreMapping?userId=${userId}&customerNumber=${customerNo}&vehicleId=${props.vehicleId}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": localStorage.getItem('apiToken'),
        "Access-Control-Allow-Origin": "*"
      }
    }).then((response => {
      console.log(response)
      console.log(response.data)
      console.log(response.data.resultSet)
      if (response.status == 200 || response.status == 204)
        getAllTyre(response.data.resultSet)
      else
        cogoToast.error('Failed to fetch tyre details...')
    }))
      .catch(error => {
        if (error?.response?.data?.message == 'No records found.')
          getAllTyre({})
        console.log(error)
      })
  }, [])

  const getAllTyre = (existingTyre) => {
    let token = localStorage.getItem('apiToken')
    let userId = localStorage.getItem('userId')
    let customerNo = localStorage.getItem('customerNo')

    Axios.get(`${APP_CONSTANTS.BASE_URL}masters/vehicleTypeTyrePositionMapping/?customerNumber=${customerNo}&userId=${userId}&vehicleTypeId=${props.id}`, {
      headers: {
        'Content-Type': 'application/json',
        "Authorization": token,
        "Access-Control-Allow-Origin": "*"
      }
    })
      .then((response => {
        let allTyreSet = response.data.resultSet
        let tyreIDForExistingTyre = [];
        let tyreSrnoList = [];

        if (existingTyre.length > 0) {
          existingTyre.forEach(element => {
            let filteredTyreInfo = {};
            filteredTyreInfo['tyrePostionName'] = element.tyrepositionName
            filteredTyreInfo['positionId'] = element.tyrePositionId
            filteredTyreInfo['prevpositionId'] = element.tyrePositionId
            filteredTyreInfo['serialNo'] = element.serialNo
            filteredTyreInfo['prevSerialNo'] = element.serialNo
            filteredTyreInfo['tyreRun'] = element.tyreRun
            filteredTyreInfo['tyreMapId'] = element.tyreMapId
            filteredTyreInfo['prevtyreMapId'] = element.tyreMapId
            filteredTyreInfo['installationDate'] = element?.installationDate ? element.installationDate != '00-00-0000 00:00' ? new Date(moment(element.installationDate.split(" ")[0], 'DD-MM-YYYY')) : '' : ''
            filteredTyreInfo['flag'] = 0//element.vehicleTypeTyrePositionMapId
            filteredTyreInfo['isDeleted'] = element.isDeleted
            filteredTyreInfo["vehicleId"] = props.vehicleId
            tyreSrnoList.push(filteredTyreInfo)
          })
          existingTyre.forEach(element => {
            tyreIDForExistingTyre.push(parseInt(element.tyrePositionId))
          });
        }

        allTyreSet.forEach(element => {
          if (!tyreIDForExistingTyre.includes(parseInt(element.positionId))) {
            let filteredTyreInfo = {};
            filteredTyreInfo['tyrePostionName'] = element.tyrePosition
            filteredTyreInfo['positionId'] = element.positionId
            filteredTyreInfo['tyrePositionId'] = element.positionId
            filteredTyreInfo['serialNo'] = ''
            filteredTyreInfo['tyreRun'] = ''
            filteredTyreInfo['tyreMapId'] = element.tyreMapId
            filteredTyreInfo['installationDate'] = element.installationDate ? element.installationDate : ''
            filteredTyreInfo['flag'] = 3
            filteredTyreInfo["isDeleted"] = 0
            filteredTyreInfo["vehicleId"] = props.vehicleId

            tyreSrnoList.push(filteredTyreInfo)
          }
        });

        setgetTyres(tyreSrnoList)
        setReceivedTyreData(tyreSrnoList)

      }))
      .catch(error => console.log(error))
  }

  const setTyreData = (index, data) => {
    console.log(data,'dataaaaa')
    let val = data.value
    let idx = index
    let infoVal = [...getTyres]
    // infoVal[idx]["serialNoPrev"] = infoVal[idx]["serialNo"]
    infoVal[idx]["serialNo"] = data.serialNo
    infoVal[idx]["productInventoryId"] = data.productInventoryId
    infoVal[idx]["flag"] = 1
    infoVal[idx]["isDeleted"] = 0
    infoVal[idx]["vehicleId"] = props.vehicleId
    infoVal[idx]["tyreMapId"] = 0
    setgetTyres(infoVal)
    setDeleteArray(infoVal)
    console.log(infoVal,'infoVal')
  }
  let tempArray = []
  const deleteTyreData = (data, index, values) => {
    console.log(data,values,'deleted datataaa')
    if (data.isDeleted == 1) {
      data.isDeleted = 0
    } else {
      data.isDeleted = 1
    }
    data.tyrePositionId = data.positionId
    data.positionId = data.positionId
    data.vehicleId = values.vehicleId
    setDeleteTyre([...deleteTyre ,data])
    let removed = getTyres.filter((item) => { if (item.isDeleted !== 1){ return item.positionId !== data.positionId }})
    setDeleteArray(removed)
  }

  let editTyreData = (obj,ind,values) => {
//     let deletePreviousTyre =[]
console.log(obj,ind,values,'obj ind values')
if(obj.serialNo !== obj.prevSerialNo){
console.log('tyre deleted' ,obj.prevSerialNo)
let temp = {}
temp['serialNo'] = obj.prevSerialNo
temp['tyreMapId'] = obj.prevtyreMapId
temp['isDeleted'] = 1
temp['tyrePositionId'] = obj.prevpositionId
temp['vehicleId'] = obj.vehicleId
console.log(temp,'edit delete')
// // deleteArray.push(temp)
// // deleteTyre.push(temp)
// // props.deletedTyre(deleteTyre)
setDeleteTyre([...deleteTyre ,temp])
if(obj.length > 0){
setgetTyres(obj)
}


}
  }

  let handleDate = (dateVal, idxs) => {
    // console.log(dateVal)
    // console.log(idxs)
    let val = dateVal ? moment(dateVal).format(DATE_FORMATS.DATE_YYYYMMDD || 'YYYY-MM-DD') : ""
    let idx = idxs
    let infoVal = [...getTyres]
    infoVal[idx]["installationDate"] = val
    setgetTyres(infoVal)
    // editTyreData(infoVal)
  }

  let handleTyrerun = (e, data) => {
    console.log(e)
    console.log(data)
    let val = data.value
    let idx = data.dataId
    let infoVal = [...getTyres]
    infoVal[idx]['tyreRun'] = val
    setgetTyres(infoVal)
    // editTyreData(infoVal)
  }

  props.tyrData(getTyres)
  props.deletedTyre(deleteTyre)
  props.deleteTyreArray(deleteArray)
  let remove = (data) => {
    console.log(data, "data")
  }



  return (
    <>

      <FieldArray
        name="tyreDetails"
      >
        {({ form }) => {
          const { values, setFieldValue } = form;
          console.log(values, "valuesss")
          return (
            <Segment>
              <Table size="small">
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell colSpan="4" ><Header color="blue" size="tiny" className="labelName p-bold-500">Tyre Details</Header></Table.HeaderCell>
                  </Table.Row>
                  <Table.Row>
                    <Table.HeaderCell className="labelName p-bold-500">Tyre Position</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-500">Serial No.</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-500">Tyre Run(Kms)</Table.HeaderCell>
                    <Table.HeaderCell className="labelName p-bold-500">Installation Date</Table.HeaderCell>
                    {/* <Table.HeaderCell textAlign="right" className="labelName p-bold-600">Delete</Table.HeaderCell> */}
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {getTyres.length > 0 ?
                    getTyres.map((object, index) => {
                      {/* console.log(('-->Date', insDate)) */ }
                      {/* { console.log("existingSerialNo return", existingSerialNumber) } */ }
                      return (
                        <Table.Row key={index + 1} onChange={()=>editTyreData(object,index, values)}   className={object.isDeleted == 1 ? 'opacityBlurr' : ''}>
                          {/* // <Table.Row key={index + 1} > */}
                          <Table.Cell>
                            <Field  component={MyNormalInput} transparent readOnly value={object.tyrePostionName} name="tyrePosition" />
                          </Table.Cell>
                          <Table.Cell className='display-flex'>
                            <Field disabled={object.cleared === 0 || (object.serialNo && object.installationDate && object.tyreRun ) ? true : false} component={VehicleAttachedSerialNumber} id={existingSerialNumber ? '' : 'searchType'}
                              placeholder={object?.serialNo ? object.serialNo : ''} setTyreData={setTyreData}
                              dataId={index} dataid={index} dataValue="srNo" existingSerialNo={existingSerialNumber}
                              typeCode={object.serialNo ? "edit" : ''} defaultValue={object.serialNo}
                              TyreId="1" name="serialNo" TyreData={object}
                             
                            />
                          </Table.Cell>
                          <Table.Cell>
                            <Field disabled={(object.serialNo && object.installationDate && object.tyreRun ) }  type="number" component={MyNormalInput} placeholder={object?.tyreRun ? object.tyreRun : ''} onChange={handleTyrerun} dataId={index} value={object.tyreRun ? Number(object.tyreRun) : ''} name="tyreRun" />
                          </Table.Cell>
                          <Table.Cell>
                            <ReactDatePicker
                              selected={object.installationDate && new Date(object.installationDate)}
                              // isClearable
                              disabled={(object.serialNo && object.installationDate && object.tyreRun ) }
                              onChange={e => handleDate(e, index)}
                              dateFormat="dd-MM-yyyy"
                              customInput={<FormUi.Input icon="time" style={{ width: '210px' }} iconPosition="left" />}
                            />
                          </Table.Cell>
                          {object?.serialNo ? <Icon disabled={(object.serialNo && object.installationDate && object.tyreRun ) }  name='trash' className='mt-10' color="red"
                            onClick={(e) => {
                              e.stopPropagation(); deleteTyreData(object, index, values);
                            }}
                          /> : null}
                        </Table.Row>
                      )
                    })
                    :
                    <Table.Row>
                      <Table.Cell>No Record(s) Found</Table.Cell>
                    </Table.Row>
                  }
                </Table.Body>
              </Table>
            </Segment>)
        }}
      </FieldArray>
    </>
  )
}

export default VehicleEditTyreTable
